import { AnyAction } from 'redux';

import VttFooter from '../api/footerEntity';
import { actionTypes } from '../common/constants/actionTypes';

export const footerReducer = (
  state: VttFooter = new VttFooter(),
  action: AnyAction
): VttFooter => {
  switch (action.type) {
    case actionTypes.FETCH_FOOTER_COMPLETED: {
      const payload = action.payload as VttFooter | null | undefined;
      return payload ? payload : state;
    }
    default:
      return state;
  }
};




// WEBPACK FOOTER //
// ./src/reducers/footer.ts